import { helpers } from '../../common/lib';
import getInitialState from '../get-initial-state';
import { actionTypes } from './actions';

export default function (state = getInitialState.list(), action) {
  switch (action.type) {
    case actionTypes.VALIDATION_ERRORS_GET_REQUEST: {
      return getInitialState.list();
    }
    case actionTypes.VALIDATION_ERRORS_GET_SUCCESS: {
      const { validationErrors } = action.payload;
      return helpers.getListReducer(state, validationErrors);
    }
    default: {
      return state;
    }
  }
}
